import "core-js/modules/es6.object.create";

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

import React from 'react';
import { Link } from 'gatsby';

var Header =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Header, _React$Component);

  function Header() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Header.prototype;

  _proto.render = function render() {
    var _this$props$data = this.props.data,
        logo = _this$props$data.logo,
        title = _this$props$data.title,
        version = _this$props$data.version;
    return React.createElement("header", {
      className: "header"
    }, React.createElement("h1", {
      className: "logo"
    }, React.createElement(Link, {
      to: logo.linkUrl
    }, React.createElement("img", {
      src: logo.src,
      alt: "logo"
    }))), title && title.text ? React.createElement("span", {
      className: "info-wrapper"
    }, React.createElement("span", {
      className: "project-name"
    }, "/"), React.createElement("span", {
      className: "project-name"
    }, React.createElement("a", {
      href: title.linkUrl,
      target: "_blank",
      rel: "noreferrer noopener"
    }, title.text))) : null, version ? React.createElement("span", {
      className: "info-wrapper" + (title && title.text ? ' has-title' : '')
    }, React.createElement("span", {
      className: "splitter"
    }, "|"), React.createElement("span", {
      className: "version"
    }, "v", version)) : null);
  };

  return Header;
}(React.Component);

export default Header;